import Button, {
  ButtonSize,
  ButtonVariant,
} from "@shared/components/ui/Button";
import ModalBlank from "../../ui/modals/ModalBlank";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isLoading: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  icon?: React.ReactNode;
}

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  icon = (
    <svg
      className="shrink-0 fill-current text-red-500"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
    </svg>
  ),
}: ConfirmationModalProps) {
  return (
    <ModalBlank
      id="confirmation-modal"
      modalOpen={isOpen}
      setModalOpen={onClose}
    >
      <div className="p-5 flex space-x-4">
        {/* Icon */}
        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-gray-100 dark:bg-gray-700">
          {icon}
        </div>
        {/* Content */}
        <div>
          {/* Modal header */}
          <div className="mb-2">
            <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              {title}
            </div>
          </div>
          {/* Modal content */}
          <div className="text-sm mb-10">
            <div className="space-y-2">
              <p>{message}</p>
            </div>
          </div>
          {/* Modal footer */}
          <div className="flex flex-wrap justify-end space-x-2">
            <Button
              size={ButtonSize.SMALL}
              variant={ButtonVariant.TERTIARY}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              {cancelText}
            </Button>
            <Button
              size={ButtonSize.SMALL}
              variant={ButtonVariant.DANGER}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : confirmText}
            </Button>
          </div>
        </div>
      </div>
    </ModalBlank>
  );
}
